import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { analyticsService } from '../../services/analytics.service';
import '../../styles/desktop-homepage-replica.css';

const MENU_ITEMS = [
  { id: 'bars', label: 'Premium Bars/Pubs for Solos', href: '/stag-venues' },
  { id: 'work', label: 'Work Cafes for Remote Workers', href: '/work' },
  { id: 'radar', label: 'Radar for Solos Nearby', href: '/radar' },
];

const MENU_BANNER_BY_CONTEXT = {
  bars: 'Premium Bars & Pubs - solo-friendly venues where you\'re welcome.',
  work: 'Work Cafes - WiFi, power, and solo-friendly spots for remote workers.',
  radar: 'Radar - see active solos nearby and decide where to go next.',
};

const DesktopMenuBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname || '/';

  const activeId = React.useMemo(() => {
    if (pathname.startsWith('/work')) return 'work';
    if (pathname.startsWith('/radar')) return 'radar';
    if (pathname.startsWith('/stag-venues')) return 'bars';
    return null;
  }, [pathname]);

  const bannerContext = activeId || 'bars';
  const bannerText = MENU_BANNER_BY_CONTEXT[bannerContext] || MENU_BANNER_BY_CONTEXT.bars;

  return (
    <nav className="dr-menu-bar" aria-label="Menu">
      <div className="dr-menu-bar__container">
        {MENU_ITEMS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`dr-menu-bar__item dr-menu-bar__item--${item.id} ${activeId === item.id ? 'dr-menu-bar__item--active' : ''}`}
            onClick={() => {
              try { analyticsService.track('nav_menu_click', { item: item.id, source: 'desktop_shell' }); } catch (_) {}
              navigate(item.href);
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div className="dr-menu-banner dr-menu-banner--slot">
        <div className={`dr-menu-banner__content dr-menu-banner--${bannerContext} dr-menu-banner__content--visible`}>
          <p className="dr-menu-banner__text">{bannerText}</p>
        </div>
      </div>
    </nav>
  );
};

export default DesktopMenuBar;
